import classNames from 'classnames';
import type { FC } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { Tailwind } from 'styles/tw';

type Props = {
  titleImageUrl: string;
  texts?: string[];
  color: Tailwind['color'];
  backgroundColor?: Tailwind['backgroundColor'];
  titleReactComponent?: React.ReactNode;
  paddingY?: Tailwind['paddingY'];
};

export const LocalePrecautions: FC<Props> = ({
  titleImageUrl,
  backgroundColor,
  color,
  texts,
  titleReactComponent,
  paddingY = 'py-10'
}) => (
  <section
    className={classNames(
      color,
      backgroundColor ?? 'bg-transparent',
      paddingY,
      'flex flex-col items-center gap-4',
      'semiLg:gap-10'
    )}
  >
    {titleReactComponent ?? <NextImage src={titleImageUrl} alt="" width={220} height={40} />}
    <ul
      className={classNames(
        'list-disc w-full max-w-[350px] text-sm leading-8 pl-6 font-medium',
        'semiLg:w-full semiLg:max-w-[1110px]'
      )}
    >
      {texts?.map((text, i) => <li key={i}>{text}</li>)}
    </ul>
  </section>
);
